import styled from "styled-components"

export const CheckboxWrapper = styled.div`
  input[type="checkbox"]:disabled {
    background: #c9cfd6;
  }
`
